@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="restorePasswordForm" (ngSubmit)="onSubmit()">
  <div class="restore-password">
    <bmcore-input formControlName="email" [title]="'Email'" [type]="'email'" [controlFormName]="'email'">
    </bmcore-input>
    <p class="bm--auth-form__hint">Enter your email address and we will send you further instructions.</p>
  </div>

  <div class="bm--auth-form-btn-container">
    <bmcore-button title="Send instructions" styleName="center" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
